import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineChart4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="line-chart-4, statistics, graph"><path d="M21.2487 16.75V19.25M15.082 12.75L15.082 19.25M8.91601 8.75V19.25M2.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLineChart4;
